import { render, staticRenderFns } from "./RemoveBUFromEngagement.vue?vue&type=template&id=3bab5596&scoped=true&"
import script from "./RemoveBUFromEngagement.vue?vue&type=script&lang=js&"
export * from "./RemoveBUFromEngagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab5596",
  null
  
)

export default component.exports